<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ _lawyerName }}</span>
		<app-button
			(click)="createOrUpdateLawyer()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateLawyerButton"
			>Create lawyer</app-button
		>
	</div>
</ng-template>

<ng-template #lawyerTemplate let-item>
	<div class="flex items-center">
		<div
			class="w-10 h-10 bg-grey-lighter rounded-md flex justify-center items-center text-sm"
		>
			{{ item.firstName[0] | uppercase }} {{ item.lastName[0] | uppercase }}
		</div>
		<div class="ml-2 font-bold whitespace-nowrap">
			{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}
		</div>
	</div>
</ng-template>

<app-member-card
	*ngIf="lawFirm?.lawyer"
	[firstName]="lawFirm?.lawyer?.firstName"
	[lastName]="lawFirm?.lawyer?.lastName"
	[email]="lawFirm?.lawyer?.email"
	[phone]="lawFirm?.lawyer?.phoneNumber"
	[ccEmail]="lawFirm?.clerk?.email"
	member="LAWYER"
	memberType="lawyer"
	[hoverShadow]="hoverShadow"
	class="w-full"
	(dropdown)="lawyerDropdownOptionSelect($event)"
	[testHook]="testHooks.MemberCard"
>
</app-member-card>

<app-auto-complete
	*ngIf="!lawFirm?.lawyer"
	label="Lawyer"
	(onSelect)="setLawyer($event)"
	placeholder="Lastname, firstname"
	[itemGroups]="[
		{ items: [{ value: 'createNew' }], template: createNewTemplate },
		{
			items: searchResult,
			template: lawyerTemplate,
			title: 'Existing Lawyers',
			noResultsMessage: 'No lawyers found',
		},
	]"
	[(ngModel)]="_lawyerName"
	name="dual-dropdown-1"
	(debounce)="searchLawyer($event)"
	[loading]="loading"
	[testHook]="testHooks.LawyerAutoComplete"
>
</app-auto-complete>
